// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import pwaInstallPrompt from "pwa-install-prompt";

new pwaInstallPrompt();
